import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";

export class AgentsTableCtrl implements IController {

  agentIds: string[];
  active: any;
  sessionRecording: any;
  termsApproved?: boolean;
  isRegistrationStatusActive: boolean;
  columns: any;
  excludeMode: any;
  agentsCount: any;
  status: any;
  queryString: any;
  team: any;
  teamIds?: string[];
  branchIds: any;
  serviceAreaIds: any;
  tags: any;
  noArea: boolean;
  noBranches: boolean;
  agentTypes: any;
  agentSkills: string[];
  depotIds: any;
  enableActions: any;
  enableSelection: any;
  selectedIds: any;
  accountId: any;
  gpsStatus: boolean;
  gpsPermissions: string[];
  doReload: any;

  onRemove?: Function;
  onChange: Function;
  onReload: Function;
  onSelectChange: Function;
  onAskToEnableGps: Function;
  onAskToEnableGpsPermissions: Function;
  onAskToClockIn: Function;
  onManageAssistants: Function;
  onRemoveFromAssistantMode: Function;
  onPasswordLess: Function;

  public isScrollable: boolean;
  private loadLimit: number;
  private agentsRef: any;
  private infiniteScroll: any;
  private expendedAgentId: string;
  private selectedKeys: any;
  public siteTimeZone: string;

  constructor(private $log, private $agents: $agentsFactory, private $infiniteScroll, private $mdMedia, private splitService) {
  }

  $onInit() {
    this.loadLimit = 50;
    this.agentsRef = this.$agents();

    this.agentsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.agentsRef, this.loadLimit);

    this.siteTimeZone = this.splitService.getTimeZone();
  }

  $onChanges(changes) {
    if (
      (changes.status && !changes.status.isFirstChange()) ||
      (changes.queryString && !changes.queryString.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange()) ||
      (changes.noBranches && !changes.noBranches.isFirstChange()) ||
      (changes.serviceAreaIds && !changes.serviceAreaIds.isFirstChange()) ||
      (changes.tags && !changes.tags.isFirstChange()) ||
      (changes.noArea && !changes.noArea.isFirstChange()) ||
      (changes.agentTypes && !changes.agentTypes.isFirstChange()) ||
      (changes.agentSkills && !changes.agentSkills.isFirstChange()) ||
      (changes.depotIds && !changes.depotIds.isFirstChange()) ||
      (changes.active && !changes.active.isFirstChange()) ||
      (changes.sessionRecording && !changes.sessionRecording.isFirstChange()) ||
      (changes.termsApproved && !changes.termsApproved.isFirstChange()) ||
      (changes.isRegistrationStatusActive && !changes.isRegistrationStatusActive.isFirstChange()) ||
      (changes.team && !changes.team.isFirstChange()) ||
      (changes.teamIds && !changes.teamIds.isFirstChange()) ||
      (changes.gpsStatus && !changes.gpsStatus.isFirstChange()) ||
      (changes.gpsPermissions && !changes.gpsPermissions.isFirstChange()) ||
      (changes.agentIds && !changes.agentIds.isFirstChange())

    ) {
      this._query();
      if (_.isFunction(this.onReload)) {
        this.onReload();
      }
    }

    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (this.doReload) {
        this._query();
        this.onReload();
      }
    }

    if (changes.selectedIds || changes.excludeMode) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }

  };

  $doCheck() {
    const numOfColumns = _.reduce(this.columns, (sum, column) => {
      return sum += column.enabled ? 1 : 0;
    }, 0);

    this.isScrollable = numOfColumns > 10 || _.isUndefined(this.columns) ? true : !this.$mdMedia('gt-md');
  }

  onAgentExpandToggle(id) {
    this.expendedAgentId = id !== this.expendedAgentId ? id : undefined;
  }

  onToggleSelectAll() {
    this.onSelectChange({selectedIds: [], excludeMode: !this.excludeMode});
  }

  onToggleSelectedAgent(agentId) {
    this.selectedKeys[agentId] = !this.selectedKeys[agentId];
    let selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.onSelectChange({selectedIds: _.compact(selectedIds), excludeMode: this.excludeMode});
  }

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  private _getQueryPayload() {
    return {
      accountIds: this.accountId,
      branchIds: this.branchIds,
      noBranches: this.noBranches,
      areaIds: this.serviceAreaIds,
      noArea: this.noArea,
      agentTypes: this.agentTypes,
      skill: this.agentSkills,
      depotIds: this.depotIds,
      status: this.status,
      query: this.queryString,
      limit: this.loadLimit,
      active: this.active,
      sessionRecording: this.sessionRecording,
      termsApproved: this.termsApproved,
      tags: this.tags,
      gpsStatus: this.gpsStatus,
      gpsPermission: this.gpsPermissions,
      expandDeviceRef: !!this.columns ? this.columns.deviceType?.enabled : true,
      ids: this.agentIds,
      registrationStatusActive: this.isRegistrationStatusActive,
      teamIds: this.teamIds?.length ? this.teamIds : _.get(this.team, 'id')
    };
  }

  private _query() {
    this.agentsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
      .finally(() => {
        //Reload Totals
        this.emitOnChange()
      });
  }

  private emitOnChange() {
    if (_.isFunction(this.onChange)) {
      this.onChange()
    }
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentsTable', {
    bindings: {
      active: '<?',
      sessionRecording: '<?',
      termsApproved: '<?',
      isRegistrationStatusActive: '<',
      columns: '<?',
      excludeMode: '<?',
      agentsCount: '<?',
      status: '<',
      queryString: '<?',
      team: '<?',
      teamIds: '<?',
      branchIds: '<?',
      serviceAreaIds: '<?',
      tags: '<?',
      noArea: '<?',
      noBranches: '<?',
      agentTypes: '<?',
      agentSkills: '<?',
      depotIds: '<?',
      enableActions: '<?',
      enableSelection: '<?',
      selectedIds: '<?',
      accountId: '<',
      gpsStatus: '<?',
      gpsPermissions: '<?',
      agentIds: '<?',
      doReload: '<',
      onRemove: '&?',
      onChange: '&',
      onAskToEnableGps: '&',
      onAskToEnableGpsPermissions: '&',
      onAskToClockIn: '&',
      onReload: '&',
      onSelectChange: '&',
      onManageAssistants: '&',
      onRemoveFromAssistantMode: '&',
      onPasswordLess: '&'
    },
    template: require('./agents-table.html').default,
    controller: AgentsTableCtrl
  });
